import { render, staticRenderFns } from "./PcStackFrames.vue?vue&type=template&id=768cb8e0&scoped=true&"
import script from "./PcStackFrames.vue?vue&type=script&lang=js&"
export * from "./PcStackFrames.vue?vue&type=script&lang=js&"
import style0 from "./PcStackFrames.vue?vue&type=style&index=0&id=768cb8e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768cb8e0",
  null
  
)

export default component.exports